import React from 'react';
import { Item } from '../../../../../../../../types';
// import ItemCreationModeSelector from './components/ItemCreationModeSelector/ItemCreationModeSelector';

import ProductDetailsForm from './components/ProductDetailsForm/ProductDetailsForm';
import CategoryAndUnitsSelector from './components/CategorySelector/CategorySelector';
import MediaUploadSection from './components/MediaUploadSection/MediaUploadSection';
import SalesChannelsConfig from './components/SalesChannelsConfig/SalesChannelsConfig';
import { MenuCategoryNode } from '../../../../../../../../types/menu.types';

interface BasicInfoSectionProps {
  items: Item[];
  itemName: string;
  setItemName: (name: string) => void;
  label: string;
  setLabel: (label: string) => void;
  price: string;
  setPrice: (price: string) => void;
  price_delivery: string;
  setPriceDelivery: (price: string) => void;
  isDelivery: boolean;
  isOnline?: boolean;
  isDesk: boolean;
  setIsDelivery: (isDelivery: boolean) => void;
  setIsOnline?: (isOnline: boolean) => void;
  setIsDesk: (isDesk: boolean) => void;
  priceDesk: string;
  setPriceDesk: (price: string) => void;
  price_online: string;
  setPriceOnline: (price: string) => void;
  description: string;
  setDescription: (description: string) => void;
  menuCategories: MenuCategoryNode[];
  selectedCategoryId: number | null | undefined;
  setSelectedCategoryId: (id: number) => void;
  setSelectedCategoryName: (name: string) => void;
  imageFiles: any;
  setImageFiles: any;
  currentItemId?: number | string; // Optional prop for update mode
  // Granel props
  isGranel: boolean;
  setIsGranel: (isGranel: boolean) => void;
  unidadesMedida: { id: number; name: string }[];
  selectedUnidadMedidaId: number;
  setSelectedUnidadMedidaId: (id: number) => void;
  selectedUnidadMedidaName: string;
  setSelectedUnidadMedidaName: (name: string) => void;
  // Workstation override
  workstationId: number | null;
  setWorkstationId: (id: number | null) => void;
  // Optional: hide MediaUploadSection (for UpdateItem when using separate upload component)
  hideMediaUpload?: boolean;
  // Third-party provider pricing
  thirdPartyProviders?: { third_party_provider_id: number; name: string }[];
  thirdPartyPrices?: { [providerId: number]: string };
  onThirdPartyPriceChange?: (providerId: number, price: string) => void;
  onThirdPartyPriceBlur?: (providerId: number) => void;
}


const CreateItem: React.FC<BasicInfoSectionProps> = ({ 
    items,
    itemName,
    setItemName,
    label,
    setLabel,
    price,
    setPrice,
    price_delivery,
    setPriceDelivery,
  isDelivery,
  isOnline,
  isDesk,
  setIsDelivery,
  setIsOnline,
  setIsDesk,
    priceDesk,
    setPriceDesk,
    price_online,
    setPriceOnline,
    description,
    setDescription,
    menuCategories,
    selectedCategoryId,
    setSelectedCategoryId,
    setSelectedCategoryName,
    imageFiles,
    setImageFiles,
    currentItemId,
    // Granel props
    isGranel,
    setIsGranel,
    unidadesMedida,
    selectedUnidadMedidaId,
    setSelectedUnidadMedidaId,
    selectedUnidadMedidaName,
  setSelectedUnidadMedidaName,
  // Workstation override
  workstationId,
  setWorkstationId,
  // Optional hide media upload
  hideMediaUpload = false,
  // Third-party provider pricing
  thirdPartyProviders,
  thirdPartyPrices,
  onThirdPartyPriceChange,
  onThirdPartyPriceBlur
 }) => {

  const handleImageFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      setImageFiles((prevFiles:any) => [...prevFiles, ...Array.from(files)]);
    }
  };

  const handleRemoveImage = (index: number) => {
    setImageFiles((prevFiles:any) => {
      const updated = [...prevFiles];
      updated.splice(index, 1);
      return updated;
    });
  };


  return (

            <>
              <ProductDetailsForm
                items={items}
                itemName={itemName}
                setItemName={setItemName}
                label={label}
                setLabel={setLabel}
                price={price}
                setPrice={setPrice}
                description={description}
                setDescription={setDescription}
                currentItemId={currentItemId}
                isGranel={isGranel}
                setIsGranel={setIsGranel}
                unidadesMedida={unidadesMedida}
                selectedUnidadMedidaId={selectedUnidadMedidaId}
                setSelectedUnidadMedidaId={setSelectedUnidadMedidaId}
                selectedUnidadMedidaName={selectedUnidadMedidaName}
                setSelectedUnidadMedidaName={setSelectedUnidadMedidaName}
              />

              <CategoryAndUnitsSelector
                menuCategories={menuCategories}
                selectedCategoryId={selectedCategoryId}
                onCategorySelect={(id: number, name: string) => {
                  setSelectedCategoryId(id);
                  setSelectedCategoryName(name);
                }}
                workstationId={workstationId}
                setWorkstationId={setWorkstationId}
              />

              <SalesChannelsConfig
                isDelivery={isDelivery}
                isOnline={isOnline}
                setIsDelivery={setIsDelivery}
                setIsOnline={setIsOnline}
                isDesk={isDesk}
                setIsDesk={setIsDesk}
                price_delivery={price_delivery}
                setPriceDelivery={setPriceDelivery}
                priceDesk={priceDesk}
                setPriceDesk={setPriceDesk}
                price_online={price_online}
                setPriceOnline={setPriceOnline}
                basePrice={price}
                currentItemId={currentItemId}
                thirdPartyProviders={thirdPartyProviders}
                thirdPartyPrices={thirdPartyPrices}
                onThirdPartyPriceChange={onThirdPartyPriceChange}
                onThirdPartyPriceBlur={onThirdPartyPriceBlur}
              />

              {!hideMediaUpload && (
                <MediaUploadSection
                  imageFiles={imageFiles}
                  handleImageFileChange={handleImageFileChange}
                  handleRemoveImage={handleRemoveImage}
                />
              )}
            </>
  );
};

export default CreateItem;